import { render, staticRenderFns } from "./viewFixedAsset.vue?vue&type=template&id=5a6d130d&scoped=true&"
import script from "./viewFixedAsset.vue?vue&type=script&lang=js&"
export * from "./viewFixedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d130d",
  null
  
)

export default component.exports